import { InjectionToken } from '@angular/core';
import type { Firestore as FirestoreInstance } from 'firebase/firestore';

export const Firestore = new InjectionToken<FirestoreInstance>(
	'marmon.firebase.firestore',
);
